module.exports = __webpack_public_path__ + "img/products_in_box.6f4cb40d.svg";